import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useRouter } from "next/router";
import { BoxColumn } from "../../components/common/Boxes";
import { shortenAddress } from "../../components/common/util";
import { PageHead } from "../../components/PageHead";
import { isDevelopment } from "../../config";
import { withProtectedRoute } from "../../context/Authentication";
import { usePlayerRecordsQuery } from "../../generated/graphql_schema";
import styles from "../../styles/Lobby.module.css";

export const Leaderboard = () => {
  const {
    data: playerStats,
    loading,
    error,
    refetch
  } = usePlayerRecordsQuery();

  // is map necessary?
  const statsForSorting = isDevelopment
    ? mockPlayerRecords
    : playerStats?.playerRecords?.map((gs) => gs);

  const isMobileView = useMediaQuery("(max-width:600px)");

  return (
    <>
      <PageHead />
      <BoxColumn
        sx={{ p: 2, alignItems: "center", overflowY: "auto", height: "100%" }}
      >
        <Typography variant="h2">Leaderboard</Typography>
        <TableContainer
          className={styles.LargeFontParent}
          sx={{
            width: isMobileView ? "100%" : "fit-content",
            minWidth: isMobileView ? 300 : 500,
            maxWidth: "100vw",
            flex: "0 0 75%",
            mb: 2
          }}
        >
          <Table
            stickyHeader
            sx={{
              background: "rgb(0,0,0,1)",
              borderRadius: 1
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Total Wins</TableCell>
                <TableCell>W/L Ratio</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {statsForSorting
                ?.sort((x, y) => (y.totalWins || 0) - (x.totalWins || 0))
                .map((stat) => (
                  <TableRow key={stat.publicAddress}>
                    <TableCell>{shortenAddress(stat.publicAddress!)}</TableCell>
                    <TableCell>{stat.totalWins}</TableCell>
                    <TableCell>
                      {(
                        (stat.totalWins || 0) / (stat.totalLosses || 1)
                      ).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </BoxColumn>
    </>
  );
};

export default Leaderboard;

const mockPlayerRecords = [
  {
    publicAddress: "0xb2200179dc60b3a876bcf27c9f3d75277d4ae40d",
    totalWins: 8,
    totalLosses: 1,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x16afc501d6fc8bf59eceb099c47856365146b3ae",
    totalWins: 4,
    totalLosses: 2,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0xbf49d2d194c0dfb8c311c69b2d25a417e02f6b59",
    totalWins: 1,
    totalLosses: 0,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x77ef025811ac5b4e6bdeb224d42018b8b710bc75",
    totalWins: 1,
    totalLosses: 2,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0xd1d69a08d5e863b6f14bb54963ecb438adc64692",
    totalWins: 2,
    totalLosses: 1,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0xcdc95167b3112cd12953c443ecf38516b0058754",
    totalWins: 1,
    totalLosses: 2,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x1282f34438cb205d201dd357398b85e7729dd3a2",
    totalWins: 0,
    totalLosses: 1,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0xef51c8be528fa9ad489fe06ab9f87bcb927bb4d2",
    totalWins: 1,
    totalLosses: 3,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x380b928af5154df6e54155da28921e9421b39229",
    totalWins: 0,
    totalLosses: 1,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x9cd066dfc97cc219319a4c45fa99fbc6f95602da",
    totalWins: 1,
    totalLosses: 0,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x70b8411e40245001bf588f17e0e87053d375fcc0",
    totalWins: 1,
    totalLosses: 1,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x47a85fc0944f4c3de37ae7bfa8ed6dededa52384",
    totalWins: 2,
    totalLosses: 2,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x49bb41acc0652b73d256cbfbd6d03a380b66c9b4",
    totalWins: 4,
    totalLosses: 0,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x033713035dd4a832b1a0b132ce57f4d98505ead7",
    totalWins: 0,
    totalLosses: 3,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x5fc797760e5c430bf4a81aa2839c6695ea3b450c",
    totalWins: 0,
    totalLosses: 3,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x7e55b88309ac120a0ba8934f8e2faab8565b59be",
    totalWins: 1,
    totalLosses: 0,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x65eebd65ff97c16df7edbc40a1b20b7cdcae101a",
    totalWins: 0,
    totalLosses: 3,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0xbf000e588ddc9f5c200b0dfccd1f87daa1d63536",
    totalWins: 2,
    totalLosses: 0,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x19ae234341234e494121fd2364d5e730a8dd9115",
    totalWins: 1,
    totalLosses: 3,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0xab5cc2deec956719632694a02b1942819ab0d349",
    totalWins: 7,
    totalLosses: 6,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0xfa346644da916ec2cb050c06226eaafb97432ef2",
    totalWins: 0,
    totalLosses: 1,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0xf296178d553c8ec21a2fbd2c5dda8ca9ac905a00",
    totalWins: 0,
    totalLosses: 1,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x6a6743b85899cc2571c8034e209f74f5a92a0e9b",
    totalWins: 1,
    totalLosses: 0,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x6ebd8991fc87f130de28de4b37f882d6cbe9ab28",
    totalWins: 1,
    totalLosses: 0,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x7d6ca8cb7251add254bf96e6e28ec7d64f58784b",
    totalWins: 0,
    totalLosses: 2,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x78ebe56bc138069557c89af35eb29023ff31ae2c",
    totalWins: 1,
    totalLosses: 0,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x02e4f367fc7cb77d9b6818440648fc4dd5d21891",
    totalWins: 0,
    totalLosses: 1,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x4ecf2d3a41f0fa23ea462b6fae68b940c453791b",
    totalWins: 0,
    totalLosses: 1,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0x04639dde98f7a4a0baae251b72d185d135054d82",
    totalWins: 2,
    totalLosses: 4,
    __typename: "PlayerStats"
  },
  {
    publicAddress: "0xb8c7088500a62ade8978659e92388c3cc331ad43",
    totalWins: 2,
    totalLosses: 0,
    __typename: "PlayerStats"
  }
];
